import React from 'react'
import { useNavigate } from 'react-router-dom'
import { formatDate } from './Utilities'

// Renders one row in the "Shared" tab of DashboardScreen. Visually mirrors
// DashboardListItem (same classes) but carries the extra attribution line
// that makes shared-with-me / shared-by-me distinguishable: who owns it and
// what role the current user has, or how many people it's shared with.
function SharedDashboardListItem({ data, variant }) {
  const navigate = useNavigate()

  const redirectHandler = () => {
    navigate(`/dashboard/${data.code_id}`)
  }

  const ownerName = variant === 'with-me' && data.owner
    ? `${data.owner.first_name || ''} ${data.owner.last_name || ''}`.trim() || 'another user'
    : null

  return (
    <div className='dashboard-item-list'>
      <div className='dashboard-item-image'>
        <img style={{ height: '3em', width: 'auto' }} src={`/static/dashboard-icons/${data.image}`} />
      </div>

      <div className='dashboard-item-meta'>
        <p className='dashboard-item-date'>Created on {formatDate(data.created_at)}</p>
        <p onClick={redirectHandler} className='dashboard-item-title'>{data.dashboard_name}</p>
        <p className='dashboard-item-description'>{data.dashboard_description}</p>
        {variant === 'with-me' ? (
          <p className='shared-dashboard-attribution'>
            <i className='fa-solid fa-user' aria-hidden='true' />
            Shared by {ownerName} · {data.role === 'editor' ? 'You can edit' : 'View only'}
          </p>
        ) : (
          <p className='shared-dashboard-attribution'>
            <i className='fa-solid fa-user-group' aria-hidden='true' />
            Shared with {data.collaborator_count} {data.collaborator_count === 1 ? 'person' : 'people'}
          </p>
        )}
      </div>
    </div>
  )
}

export default SharedDashboardListItem
